import { render, staticRenderFns } from "./WidgetHotelStatDesti.vue?vue&type=template&id=9e93bb6a&scoped=true"
import script from "./WidgetHotelStatDesti.vue?vue&type=script&lang=js"
export * from "./WidgetHotelStatDesti.vue?vue&type=script&lang=js"
import style0 from "./WidgetHotelStatDesti.vue?vue&type=style&index=0&id=9e93bb6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e93bb6a",
  null
  
)

export default component.exports